const proConversionEventNames = {
  userStartedProConversion: 'userStartedProConversion',
  userSubmittedProInfo: 'userSubmittedProInfo',
  userSubmittedProPayment: 'userSubmittedProPayment',
  userCompletedProConversion: 'userCompletedProConversion',
  userCancelledPlan: 'userCancelledPlan',
  userClickedGetMoreCodes: 'userClickedGetMoreCodes',
  Revenue_Global_Clicked_UpgradeButton: 'Revenue_Global_Clicked_UpgradeButton',
  Revenue_PaymentForm_Selected: 'Revenue_PaymentForm_Selected',
  Revenue_ProFlex_BillingTab_Reached: 'Revenue_ProFlex_BillingTab_Reached',
  Revenue_Invoices_UserClicked: 'Revenue_Invoices_UserClicked',
  Revenue_DowngradeConfirmationModal_UserClicked: 'Revenue_DowngradeConfirmationModal_UserClicked',
  Flowcode_Homepage_Clicked_Signup_Google: 'Flowcode_Homepage_Clicked_Signup_Google',
  Flowcode_Homepage_Clicked_Signup_Facebook: 'Flowcode_Homepage_Clicked_Signup_Facebook',
  Pro_Flex_Demo_Modal_Redirected: 'Pro_Flex_Demo_Modal_Opened',
  Flowcode_Management_Clicked_Dropdown_Download_Code:
    'Flowcode_Management_Clicked_Dropdown_Download_Code',
  Flowcode_Management_Clicked_Settings_Dropdown: 'Flowcode_Management_Clicked_Settings_Dropdown',
  Flowcode_Management_Clicked_Delete_Modal: 'Flowcode_Management_Clicked_Delete_Modal',
  Flowcode_Management_Clicked_Share_Dropdown: 'Flowcode_Management_Clicked_Share_Dropdown',
  Flowcode_Management_Clicked_Copy_Link: 'Flowcode_Management_Clicked_Copy_Link',
  Flowcode_Management_Clicked_Add_To_Folder: 'Flowcode_Management_Clicked_Add_To_Folder',
  Flowcode_Management_Clicked_Expand_Options: 'Flowcode_Management_Clicked_Expand_Options',
  Flowcode_Management_Clicked_Learn_How_To_Use_Video:
    'Flowcode_Management_Clicked_Learn_How_To_Use_Video',
  Flowcode_Management_Clicked_Help_Center: 'Flowcode_Management_Clicked_Help_Center',
  Flowcode_Management_Clicked_Email_Us: 'Flowcode_Management_Clicked_Email_Us',
  Flowcode_Management_Edit_Code_Typed_Flowcode_Name:
    'Flowcode_Management_Edit_Code_Typed_Flowcode_Name',
  Flowcode_Management_Edit_Code_Clicked_Transfer_Code:
    'Flowcode_Management_Edit_Code_Clicked_Transfer_Code',
  Flowcode_Management_Edit_Code_Clicked: 'Flowcode_Management_Edit_Code_Clicked',
  Revenue_LoggedInGenerator_Clicked_CreateAndDownloadButton:
    'Revenue_LoggedInGenerator_Clicked_CreateAndDownloadButton',
  ProTrialModal_Clicked_PrimaryButton: 'ProTrialModal_Clicked_PrimaryButton',
  ProTrialModal_Clicked_SecondaryButton: 'ProTrialModal_Clicked_SecondaryButton'
}
export default proConversionEventNames
